import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {
  GetPersonTaggingDiagnosticsRequest,
  RawPersonTaggingDiagnostics,
} from './types'

export interface GetPersonTaggingDiagnostics<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const getPersonTaggingDiagnostics: GetPersonTaggingDiagnostics<
  GetPersonTaggingDiagnosticsRequest,
  RawPersonTaggingDiagnostics
> = (http, params) => {
  const {PersonID, ClientID, Season} = params

  const queryParams: string[] = []
  queryParams.push(`clientid=${ClientID}`)
  // Only append season when one was explicitly chosen — the default path must
  // send no season param at all so the server can resolve "most recent season
  // with data" from the tag rows.
  if (Season !== undefined) {
    queryParams.push(`season=${Season}`)
  }
  const query = `?${queryParams.join('&')}`

  const path = `/v2/faces/persons/${PersonID}/tagging-diagnostics`

  return http.request<RawPersonTaggingDiagnostics>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
